export const project = [
  {
    title: "FemmeCare",
    link: "https://tech-monk-femmcare.vercel.app/",
    coverImage: "https://user-images.githubusercontent.com/80174214/211193256-39bdaed6-b0c2-4efb-8fb0-e5745b15f11d.png",
    description: "Revolutionizing female healthcare. Contains resources, realtime chat app & mental health tracker. Built using React.js, TailwindCSS, Node.js, Express.js, Socket.io",
  },
  {
    title: "Jordle",
    link: "https://abhilipsasahoo03.github.io/Jordle/",
    coverImage: "https://user-images.githubusercontent.com/80174214/239004435-4fd149b9-d332-407f-ae3b-7740f81fcf21.jpg",
    description: "A Wordle Clone with dark mode feature. Built using HTML, CSS and JavaScript with animate.css and toastr for non-blocking notifications.",
  },
  {
    title: "Personal Portfolio",
    link: "https://csb-w3vic5.vercel.app/",
    coverImage: "https://user-images.githubusercontent.com/80174214/239005513-e63df9ec-ffa6-4c72-b472-6ae37efc0eec.jpg",
    description: "My personal portfolio project built using React, TailwindCSS and Hashnode's GraphQL API.",
  }
];
